// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"93905c04","703":"7602de94","885":"1fdeb864"}[chunkId] + ".chunk.js";
};